import api from "apis/courseGroup";
import { WebApiRequest, HTTP_GET, HTTP_POST, HTTP_PUT, HTTP_DELETE } from "tools/webservice";

export const addGroup = (group, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  payload: group,
  endpoint: api.addGroup(),
  successCallback,
  errorCallback,
  mountedRef,
});

export const updateGroup = (group, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_PUT,
  payload: group,
  endpoint: api.updateGroup(),
  successCallback,
  errorCallback,
  mountedRef,
});

export const deleteGroup = (groupId, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_DELETE,
  endpoint: api.deleteGroup(groupId),
  successCallback,
  errorCallback, //used specifically if the group delete fails because it is actively being used and therefore cant be deleted
  mountedRef,
});

export const getGroups = (successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.getGroups(),
  successCallback,
  mountedRef,
});
